// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * NOTE: The top four hex digits correspond to the entity type. We do not
 * have this encoded in the codebase yet, so for now you must make absolutely
 */
export enum EntityPropertySchemaBuf {
  FileIdValue = 0,
  UserIdValue = 1,
  SharedFolderIdValue = 2,
  ConversationIdValue = 4,
  SearchIdValue = 5,
  UtcTimestampMillisValue = 16,
  S3BlobUriValue = 32,
  S3ThumbnailUriValue = 33,
  S3PdfUriValue = 34,
  NonEmptyStringValue = 48,
  AnyStringValue = 49,
  HashableTagValue = 50,
  EmailValue = 51,
  EntityHandleValue = 52,
  WebUrlValue = 53,
  AnyJsonValue = 54,
  BoolValue = 64,
  PositiveIntegerValue = 80,
  PositiveFloatValue = 81,
  SizeBytesValue = 82,
  AnyIntegerValue = 83,
  NonNegativeIntegerValue = 84,
  PackedBytesValue = 85,
  UnpackedRawBytesValue = 86,
  MimeTypeValue = 96,
  ExifJsonStringValue = 97,
  Sha256HashValue = 98,
  SearchIndexingStatusValue = 99,
  FolderResponseDetailsValue = 100,
  FileThumbnailSetValue = 101,
  FileAudioContainerMetadataValue = 102,
  FileVideoContainerMetadataValue = 103,
  FilePdfContainerMetadataValue = 104,
  FileLinkOpenGraphMetadataValue = 105,
  ConversationTurnValue = 106,
  FileDownloadSourceApplicationValue = 107,
  FileMatchedEmbeddingsValue = 108,
  RoleUuidValue = 256,
  FileRefPayloadValue = 257,
  FileSharingInviteValue = 258,
  EntityPropertySelectionValue = 272,
  ViewModeSettingsValue = 273,
  UserSidebarItemIdValue = 274,
  UserActionValue = 275,
  UserSidebarIdValue = 276,
  SqlBrotliVacuumBytesValue = 277,
  SearchResultValue = 278,
  SearchLocationsValue = 279,
  SearchPropertiesValue = 280,
  SearchDefinitionValue = 281,
  UserInterfaceSettingsValue = 288,
  UserRefreshTokenValue = 289,
  YoutubeVideoMetadataValue = 290,
  UserNotificationValue = 291,
  _UnusedSchema = 286331153
}
